import React from 'react'
import { IconProps } from 'types/common'

const RecipeIcon: React.FC<IconProps> = ({
    width = 24,
    height = 24,
    stroke = 'currentColor',
    fill = 'currentColor'
}) => {
    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_94_3232)">
                <path d="M4.5 10.5C4.5 8.51088 5.29018 6.60322 6.6967 5.1967C8.10322 3.79018 10.0109 3 12 3C13.9891 3 15.8968 3.79018 17.3033 5.1967C18.7098 6.60322 19.5 8.51088 19.5 10.5" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M8.40039 10.5C8.74619 8.80595 9.66666 7.28341 11.006 6.19004C12.3454 5.09668 14.0214 4.49965 15.7504 4.5C16.02 4.50014 16.2895 4.51454 16.5576 4.54313" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12.625 10.5001C13.1135 9.38262 13.8668 8.4009 14.8197 7.63974C15.7727 6.87858 16.8966 6.36087 18.0944 6.13135" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M8.25 18.6844C6.68304 17.9662 5.35529 16.8131 4.4246 15.3622C3.49392 13.9113 2.99946 12.2237 3 10.5H21C21.0005 12.2237 20.5061 13.9113 19.5754 15.3622C18.6447 16.8131 17.317 17.9662 15.75 18.6844V19.5C15.75 19.6989 15.671 19.8897 15.5303 20.0303C15.3897 20.171 15.1989 20.25 15 20.25H9C8.80109 20.25 8.61032 20.171 8.46967 20.0303C8.32902 19.8897 8.25 19.6989 8.25 19.5V18.6844Z" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_94_3232">
                    <rect width={width} height={height} fill={fill}/>
                </clipPath>
            </defs>
        </svg>
    )
}

export default RecipeIcon